import { t } from '@bg-shared/business/Translate';
import {
    GamificationErrorType,
    IGamificationError,
} from '@bg-shared/business/Gamification/interfaces';
import { parseErrorText } from './parseErrorText';

const ERROR_PREFIX = 'CUP_ERROR';

export const parseGamificationError = (error: GamificationErrorType): string => {
    const errorId = (error as IGamificationError)?.error_id;
    const errorCode = (error as IGamificationError)?.errorCode;
    const monolithError = (error as IGamificationError)?.error;

    if (errorCode) {
        const translatedError = t.error(errorCode);

        if (translatedError !== errorCode) {
            return translatedError.toLocaleUpperCase();
        }

        console.warn(`Unmapped gamification error code: ${errorCode}`, error);
    }

    if (errorId) {
        const mappingErrorMessageKey = `${ERROR_PREFIX}_${errorId}`;
        const translatedError = t.error(mappingErrorMessageKey);

        if (translatedError !== mappingErrorMessageKey) {
            return translatedError.toLocaleUpperCase();
        }

        console.warn(`Unmapped gamification error ID: ${errorId}`, error);
    }

    if (monolithError) {
        const translatedError = t.gamification(monolithError);

        if (translatedError !== monolithError) {
            return translatedError.toLocaleUpperCase();
        }

        console.warn(`Unmapped gamification error: ${monolithError}`, error);
    }

    return parseErrorText(error as Error | { message: string }).toLocaleUpperCase();
};
